<template>
  <el-dialog
    :title="$t('text.export_patient_data')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="closeDialog()"
    v-if="dialogVisible"
    width="800px"
  >
    <el-tabs type="border-card" v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('text.export_data')" name="exportData">
        <div class="p-10">
          <div>
            {{ $t('text.export_patient_data_desc') }}
            <b>{{ $store.state.patient.selectedPatient.alias }}</b>
          </div>
          <el-button
            class="common-btn min-w-80 mt-20"
            :loading="exportLoading"
            :disabled="exportLoading"
            @click="exportPatientData()"
            >{{ $t('text.export_patient_data') }}</el-button
          >
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('text.available_files')" name="availableFiles">
        <ReportHistoryTable ref="reportHistoryTable" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import ReportHistoryTable from '@/components/manage/patients/ReportHistoryTable.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      exportLoading: false,
      activeTab: 'exportData'
    }
  },
  components: {
    ReportHistoryTable
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.activeTab = 'exportData'
      this.dialogVisible = false
    },
    exportPatientData() {
      this.exportLoading = true
      ApiService.GetPatientDataExport(
        this.$store.getters[`user/selecteOrganisationId`],
        this.$store.state.patient.selectedPatient.patientId
      )
        .then(response => {
          this.exportLoading = false
          if (response.data.Success) {
            swal({
              icon: 'success',
              title: this.$t('text.export_in_progress'),
              text: this.$t('text.export_report_success_text')
            })
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.FailureInformation
            })
          }
        })
        .catch(() => {
          this.exportLoading = false
          swal({
            icon: 'error',
            title: this.$t('text.failed')
          })
        })
    },
    handleTabClick() {
      if (this.activeTab === 'availableFiles') {
        this.$refs.reportHistoryTable.getData()
      }
    }
  }
}
</script>
